import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { merge } from 'rxjs';
import { UserDAO } from '../../../../../core/services/dao/userDAO';
import { RoleDAO } from '../../../../../core/services/dao/roleDAO';
import { AuthService } from '../../../../../core/services/auth.service';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../../core/services/apiHelper';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class EditUserResolve implements Resolve<any> {
  constructor(
    private userDAO: UserDAO,
    private roleDAO: RoleDAO,
    private authService: AuthService,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const userResolve = this.userDAO.loadById(route.params.id);
    const sessionResolve = this.authService.checkSession();

    const mergeResolve = merge(userResolve, sessionResolve);
    return mergeResolve.pipe(
      take(2),
      map((data) => data),
    );
  }
}
